import React from 'react';
import PvsCampaignContainer from 'containers/PvsCampaignContainer';
import ThomasAdvertiserContainer from 'containers/ThomasAdvertiserContainer';
import PvsCampaignView from 'views/components/PvsCampaigns/PvsCampaignView';

interface PvsCampaignPageProps {
  campaignId: any;
}

const ThomasCampaignPage: React.FunctionComponent<PvsCampaignPageProps> = ({ campaignId }) => {
  console.log('campaignId: ', campaignId);

  return (
    <PvsCampaignContainer pvs_campaign_id={campaignId}>
      {({ pvs }) =>
        pvs && (
          <ThomasAdvertiserContainer tgrams_id={pvs.tgrams_id}>
            {({ thomasAdvertiser }) => (
              <PvsCampaignView advertiser={thomasAdvertiser} campaign={pvs} />
            )}
          </ThomasAdvertiserContainer>
        )
      }
    </PvsCampaignContainer>
  );
};

export default ThomasCampaignPage;
